<template>
  <centered-component>
    <div class="ui pagination compact menu">
      <a
        v-for="(page, index) in pagination.indices"
        @click="$emit('new-page-selected', index)"
        class="item"
        :class="{ active: page === pagination.currentPage }"
        :key="`page-${page + 1}`">
        {{ page + 1 }}
      </a>
    </div>
  </centered-component>
</template>

<script>
import CenteredComponent from './utility/CenteredComponent'

export default {
  name: 'Pagination',
  components: { CenteredComponent },
  props: {
    items: {
      type: Object,
      required: true
    }
  },
  computed: {
    pagination () {
      let results = this.items

      let pages = Math.ceil(results.total / results.limit)

      let currentPage = Math.ceil(results.startIndex / results.limit)

      let indices = []

      for (let i = 0; i < pages; i++) { indices.push(i) }

      return { indices, currentPage }
    }
  }
}
</script>

<style scoped>

</style>
